import { SxProps, Theme } from '@mui/material';

const detailContainer: SxProps<Theme> = (theme) => ({
  display: 'flex',
  justifyContent: 'space-between',
  paddingTop: theme.spacing(3.75),
  alignItems: 'center',
});

const styles = {
  detailContainer,
};

export default styles;
